import BezierEasing from './BezierEasing.js'

var isPlaying = false;
var rafQueue = []
function removeFromRaf(animation) {
    for (let i=0; i<rafQueue.length; i++) {
        if (rafQueue[i] == animation) {
            rafQueue.splice(i,1)
            break;
        }
    }
}
function addToRaf(animation) {
    let isInRaf = false
    rafQueue.forEach((anim)=>{
        if (anim == animation) {
            isInRaf = true
        }
    })  
    if (!isInRaf) {
        rafQueue.push( animation )
    } 
}

function update() {
    requestAnimationFrame(update)
    rafQueue.forEach((anim)=>{
        anim && anim.update()
    });
}

export default class WebAnimation {
    constructor(options) {
        this.debug     = options.debug
        this.step      = options.step || function(){}
        this.end       = options.end || function(){}
        this.direction = options.direction || 1;
        this.duration  = options.duration || 1000;
        this.easing    = options.easing || [0.250, 0.250, 0.750, 0.750];
        this.delay     = options.delay  || 0;
        this._progress = 0;
        this._easedProgress = 0;
    }
    destroy() {
        removeFromRaf(this)
    }
    play() {
        this.delayProgress  = 0;
        this._progress      = this.direction == 1 ? 0 : 1
        this._easedProgress = this.direction == 1 ? 0 : 1
        this.isPlaying      = true;
        this.lastDate       = (window.performance || Date).now()
        addToRaf(this)
        if (!isPlaying) {
            isPlaying = true;
            update()
        }
    }
    pause() {
        clearTimeout(this._delayTimer)
        this.isPlaying = false;
    }
    reset() {
        this.lastDate  = (window.performance || Date).now()
        this._progress = 0;
    }
    update() {
        
        if (this.isPlaying) {  

            const d = ((window.performance || Date).now() - this.lastDate) 
            
            this.lastDate = (window.performance || Date).now()
            
            if (this.delayProgress<this.delay) {
                this.delayProgress  += d
                return;
            }

            this._progress += d / this.duration // * this.direction;

            let easing = BezierEasing( this.easing[0], this.easing[1],  this.easing[2],  this.easing[3] )
            this._easedProgress = easing( Math.max(0, Math.min(1, this._progress))  ) 
           
            if ( (this.direction == 1 && this._easedProgress < 1) || 
                 (this.direction == -1 && this._easedProgress > 0)    ) {            
                this.step( this._easedProgress , this._progress);
            }
            else {
                this.isPlaying = false;
                this._progress      = this.direction == 1 ? 1 : 0;
                this._easedProgress =  this.direction == 1 ? 1 : 0;
                this.step( this._easedProgress , this._progress);
                this.end();
            }
            
        }
    }
}
